import { generateClient } from "aws-amplify/api";
import { updateUserProfile } from "../../graphql/mutations";

const client = generateClient();

const updateUserData = async (
  type,
  newData,
  userProfile,
  setUserProfile,
  buttonAction
) => {
  let userObjectCopy = { ...userProfile };
  switch (type) {
    case "updateTask":
      userObjectCopy.tasks = newData;
      break;
    case "task":
      // let tasksPlaceholder = userObjectCopy.tasks
      let tasksPlaceholder = userObjectCopy.tasks;
      tasksPlaceholder.push(newData);
      userObjectCopy.tasks = tasksPlaceholder;
      break;
    case "deleteTask":
      let deleteTasksPlaceholder = userObjectCopy.tasks;
      const indexToDelete = deleteTasksPlaceholder.indexOf(newData);
      if (indexToDelete > -1) {
        deleteTasksPlaceholder.splice(indexToDelete, 1);
      }
      userObjectCopy.tasks = deleteTasksPlaceholder;
      break;
    case "deleteGoal":
      let deleteGoalsPlaceholder = userObjectCopy.goals;
      const goalIndexToDelete = deleteGoalsPlaceholder.indexOf(newData);
      if (goalIndexToDelete > -1) {
        deleteGoalsPlaceholder.splice(goalIndexToDelete, 1);
      }
      userObjectCopy.goals = deleteGoalsPlaceholder;
      break;
    case "updateGoal":
      userObjectCopy.goals = newData;
      break;
    case "goal":
      let goalsPlaceholder = userObjectCopy.goals;
      goalsPlaceholder.push(newData);
      userObjectCopy.goals = goalsPlaceholder;
      break;
    case "addPillar":
      let pillarPlaceholder = userObjectCopy.pillars;
      pillarPlaceholder.push(newData);
      userObjectCopy.pillars = pillarPlaceholder;
      break;
    case "updatePillars":
      userObjectCopy.pillars = newData;
      break;
    case "updateProjects":
      userObjectCopy.projects = newData;
      break;
    case "updateMorningRoutine":
      userObjectCopy.morningRoutineSteps = newData;
      break;
    case "updateEveningRoutine":
      userObjectCopy.eveningRoutineSteps = newData;
      break;
    default:
  }
  try {
    const updatedUserObject = await client.graphql({
      query: updateUserProfile,
      variables: {
        input: {
          id: userProfile.id,
          tasks: userObjectCopy.tasks,
          goals: userObjectCopy.goals,
          pillars: userObjectCopy.pillars,
          projects: userObjectCopy.projects,
          morningRoutineSteps: userObjectCopy.morningRoutineSteps,
          eveningRoutineSteps: userObjectCopy.eveningRoutineSteps
        },
      },
      authMode: "userPool",
    });
    console.log("user updated");
    console.log(updatedUserObject);
    setUserProfile(updatedUserObject.data.updateUserProfile);
    buttonAction();
  } catch (err) {
    console.log("error updating user object", err);
  }
};

export default updateUserData;
